module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '86w36zcd',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
